/*
 * @description: 
 * @author: Jason Wong
 * @since: 2026-01-21 09:57:30
 */
import LayoutEX from "@/views/layout/LayoutEx";
import config from "@/configs/pathConfigures";

const dataPoints = {
  path: config.prefixUrl + '/dataPoints',
  component: LayoutEX,
  redirect: { name: "dataPointsStat" },
  props: {
    routeMapClass: "route-map__float",
  },
  children: [
    {
      name: "dataPointsStat",
      path: "stat",
      component: () => import("@/views/aigc/DataStats.vue"),
      meta: { title: "数据统计" },
    },
  ]
}

export { dataPoints };
